// import React, { useEffect, useRef, useState } from 'react';
// import Slider from 'react-slick';

// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import { useEffect, useState, useContext } from 'react';

import { ReactComponent as DocumentIcon } from '../../assets/icons/document.svg';
import { ReactComponent as DocumentIconDark } from '../../assets/icons/iconsDark/document-dark.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/remove-icon.svg';
import { ReactComponent as TickIcon } from '../../assets/icons/tick-icon.svg';
import ThemeContext from '../../contexts/theme-context/ThemeContext';
import { SingleFileUploadProgress } from '../../interface/file-upload-stream.interface';
import { useAppSelector } from '../../redux/hooks';

/**
 * File upload progress component
 */
function FileUploadProgress() {
  // const sliderRef = useRef<Slider>(null);
  // const [slideIndex, setSlideIndex] = useState<number>(2);
  const { theme } = useContext(ThemeContext);
  const { fileUploadProgress } = useAppSelector((state) => state.fileUpload);
  const [currentlyUploading, setCurrentlyUploading] = useState<SingleFileUploadProgress>(
    fileUploadProgress?.[0] || {},
  );

  /**
   *
   */
  // const handleNextFileUpload = (index: number) => {
  //   setSlideIndex(index);
  //   if (sliderRef.current) {
  //     sliderRef.current.slickGoTo(index); // Programmatically go to the clicked slide
  //   }
  // };

  // useEffect(() => {
  //   handleNextFileUpload(2);
  // }, []);

  // const settings = {
  //   dots: false,
  //   arrow: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 3500,
  // };

  useEffect(() => {
    const currentlyUploadProgress = fileUploadProgress?.find(
      (eachProgress) => eachProgress.currentlyUploading === true,
    );
    if (currentlyUploadProgress) {
      setCurrentlyUploading(currentlyUploadProgress);
    }
  }, [fileUploadProgress]);

  return (
    <div className="file-upload-progress-wrap">
      <div className="file-upload-slider">
        {/* <Slider
          ref={sliderRef}
          dots={settings.dots}
          arrows={settings.arrow}
          infinite={settings.infinite}
          speed={settings.speed}
          slidesToShow={settings.slidesToShow}
          slidesToScroll={settings.slidesToScroll}
          autoplay={settings.autoplay}
          autoplaySpeed={settings.autoplaySpeed}
          draggable={false}
          centerMode>
          {fileUploadProgress?.map((fileUpload, index) => (
            <div className={`each-file-slider ${slideIndex + 1 === index ? 'active' : ''}`}>
              <div className="single-file-upload-list">
                <div className="file-details">
                  <span>
                    <DocumentIcon />
                  </span>
                  <p>{fileUpload.fileName}</p>
                </div>
                <div className="file-status">
                  {fileUpload.status === 'pending' ? <CloseIcon /> : <TickIcon />}
                </div>
              </div>
            </div>
          ))}
        </Slider> */}
        <div className="single-file-upload-list">
          <div className="file-details">
            <span>{theme === 'light' ? <DocumentIcon /> : <DocumentIconDark />}</span>
            <p>{currentlyUploading?.fileName}</p>
          </div>
        </div>
        <div className="upload-progress-wrap">
          <p>{currentlyUploading.progress}%</p>
          <div className="upload-progress-container">
            <div
              className="upload-progress-bar"
              style={
                {
                  width: `${currentlyUploading.progress}%` || '0%',
                } as React.CSSProperties
              }
            />
          </div>
        </div>
      </div>
      <div className="file-upload-list-wrap">
        {fileUploadProgress?.map((eachFile) => (
          <div className="single-file-upload-list">
            <div className="file-details">
              <span>{theme === 'light' ? <DocumentIcon /> : <DocumentIconDark />}</span>
              <p>{eachFile.fileName}</p>
            </div>
            <div className="file-status">
              {eachFile.status === 'pending' ? <CloseIcon /> : <TickIcon />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FileUploadProgress;
